import { register } from '../../../../Javascript/Sysmex/Utils'

const DisableOnClick = el => {
  const prefix = el.dataset.prefix

  // this is a workaround since el.form.submit() + el.disabled = true is very buggy within the form framework
  el.addEventListener('click', () => { el.classList.add(`${prefix}is--disabled`) })
}

register('DisableOnClick', DisableOnClick)
